import React from "react";
import "./style.css";
import {MONEY_BACK_POLICY, PRIVACY_POLICY, TERMS_OF_USE} from "../../../../../../enum/NavigationEnum";

import { Image } from "../../../../../../components/Image";
export const PayCard = ({setDisplayNav, bottomRef}) => {
  return (
    <div className="pay-card" ref={bottomRef}>
      <div className="container-10">
        <Image src="/static/image/questionnaire/weight-loss/payScreen/img-4.png" alt="Img" className="img-3" />

        <div className="guarantee-title">
          <div className="guarantee-title-text">100% Money-Back Guarantee</div>
        </div>
      </div>

      <p className="description">
        <span className="text-wrapper-9">
          We believe that our plan can work for you and you will get visible
          results in 4 weeks! We are even willing to return your money if you
          don't see visible results and can prove that you followed our plan.
          <br />
          Find more about applicable limitations in our{" "}
        </span>

        <span className="text-wrapper-10" onClick={() => {setDisplayNav(MONEY_BACK_POLICY)}} >money-back policy </span>
      </p>

      <div className="footer-text"> <span onClick={() => {setDisplayNav(PRIVACY_POLICY)}}>Privacy Policy</span> , <span onClick={() => {setDisplayNav(TERMS_OF_USE)}}>Terms of Use</span></div>
    </div>
  );
};
